import { render } from "./App-index.vue?vue&type=template&id=609a07f6"
import script from "./App-index.vue?vue&type=script&lang=js"
export * from "./App-index.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Desarrollo\\Documents\\Inventarios 2.0\\Technosoft.Inventarios.v2\\Technosoft.Inventarios.v2.UI.Web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__